// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./app/widgets/navigation/report-options2/simple-filter/simple-filter.component.css
// module id = 468
// module chunks = 0